module.exports = __webpack_public_path__ + "static/media/deliverymenew-logo.8c8b1537.svg";